import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-buttons-footer',
    templateUrl: './buttons-footer.component.html',
    styleUrls: ['./buttons-footer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ButtonsFooterComponent implements OnInit {
    @Input() steps = 0;
    @Input() currentStep = 0;

    constructor() {
    }

    ngOnInit(): void {
    }

}
